import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Flame } from "lucide-react";
import FeedPostCard from "@/components/FeedPostCard";

export default function Trending() {
    const [items, setItems] = useState(null);

    useEffect(() => {
        api.get("/social/trending?limit=30")
            .then((r) => setItems(r.data.items || []))
            .catch(() => setItems([]));
    }, []);

    return (
        <div className="max-w-3xl mx-auto px-4 md:px-8 py-10" data-testid="trending-page">
            <div className="flex items-center gap-3 mb-2">
                <Flame className="h-7 w-7 text-[#ff4500]" />
                <h1 className="font-display text-4xl sm:text-5xl tracking-wide">What's Hot</h1>
            </div>
            <p className="text-sm text-[#a0a0a0] mb-8">The most reposted, followed and talked-about posts across Travel Sports right now.</p>

            {items == null ? (
                <div className="text-sm text-[#a0a0a0] py-16 text-center">Loading…</div>
            ) : items.length === 0 ? (
                <div className="border border-[#2a2a2a] py-16 text-center text-sm text-[#a0a0a0]" data-testid="trending-empty">
                    Nothing trending yet — start reposting, following and commenting to heat things up.
                </div>
            ) : (
                <div className="space-y-4">
                    {items.map((it) => (
                        <FeedPostCard key={`${it.post_type}-${it.id}`} item={it} />
                    ))}
                </div>
            )}
        </div>
    );
}
